import { call, take, put } from 'redux-saga/effects';
import { get, putMethod, deleteMethod, post } from '../../utils/api';
import settings from '../../utils/settings';
import { getBelongsTo, setSolargrafToken } from '../../utils/helper';
import { get as lodashGet, isEmpty, cloneDeep } from '../../utils/lodash';

import {
  GET_COMPANY_INFO_REQUEST,
  GET_COMPANY_INFO_SUCCESS,
  REQUEST_FAILURE,
  UPDATE_COMPANY_INFO_REQUEST,
  UPDATE_COMPANY_INFO_SUCCESS,
  UPDATE_COMPANY_INFO_FAILURE,
  GET_BANNER_DATA_REQUEST,
  GET_BANNER_DATA_SUCCESS,
  GET_SFDC_REQUEST,
  GET_SFDC_SUCCESS,
  GET_SFDC_FAILURE,
  UPDATE_ACCOUNT_MANAGER_REQUEST,
  UPDATE_ACCOUNT_MANAGER_SUCCESS,
  UPDATE_ACCOUNT_MANAGER_FAILURE,
  GET_AB_FEATURE_REQUEST,
  GET_AB_FEATURE_SUCCESS,
  GET_AB_FEATURE_FAILURE,
  GET_USER_DETAILS,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAILURE,
  GET_IMAGE_BANNER_DATA_REQUEST,
  GET_IMAGE_BANNER_DATA_SUCCESS,
  GET_APPLICATION_NOTIFICATIONS_REQUEST,
  GET_APPLICATION_NOTIFICATIONS_SUCCESS,
  GET_APPLICATION_NOTIFICATIONS_FAILURE,
  READ_APPLICATION_NOTIFICATIONS_REQUEST,
  READ_APPLICATION_NOTIFICATIONS_FAILURE,
  MARK_NOTIFICATION_AS_SEEN_REQUEST,
  GET_APPLICATION_REQUEST,
  GET_APPLICATION_SUCCESS,
  GET_APPLICATION_FAILURE,
  DELETE_READ_NOTIFICATION_REQUEST,
  GET_SOLARGRAF_ACCESS,
  SET_SOLARGRAF_ACCESS_GRANT,
  GET_SOLARGRAF_SESSION,
  GET_SOLARGRAF_SESSION_SUCCESS,
  VERIFY_SOLARGRAF_SESSION,
  VERIFY_SOLARGRAF_EMAIL,
  GET_PROJECT_DETAILS_REQUEST,
  GET_PROJECT_DETAILS_SUCCESS,
  GET_PROJECT_DETAILS_FAILURE,
  GET_SITE_DETAILS_SUCCESS,
  GET_SITE_DETAILS_REQUEST,
  GET_SITE_DETAILS_FAILURE,
  CAN_APPLY_DRS_FOR_CC_REQUEST,
  CAN_APPLY_DRS_FOR_CC_SUCCESS,
  CAN_APPLY_DRS_FOR_CC_FAILURE,
  CREATE_DRS_APPLICATION_REQUEST,
  CREATE_DRS_APPLICATION_SUCCESS,
  CREATE_DRS_APPLICATION_FAILURE,
  SET_ENLIGHTEN_VERSION_FOOTER,
  GET_ENLIGHTEN_VERSION_FOOTER
} from './constants';

export function* companyInfoFlow() {
  while (true) {
    const request = yield take(GET_COMPANY_INFO_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(
          `service/enlm_ms/api_internal/company/${request.companyId}`
        )
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        const country = lodashGet(result.company, `address.country`);
        const belongsToList = getBelongsTo(country);
        const cloneMasterData = cloneDeep(result.master_data);
        cloneMasterData.year_range.reverse();
        yield put({
          type: GET_COMPANY_INFO_SUCCESS,
          companyInfo: result.company_info,
          company: result.company,
          masterData: cloneMasterData,
          eligibleForEin: result.eligible_for_ein,
          einUrls: result.ein_urls,
          dashboardLinks: result.dashboard_links,
          countryCode: country,
          ...belongsToList
        });
      } else {
        yield put({
          type: REQUEST_FAILURE,
          error: result.message || result.messages
        });
      }
    } catch (error) {
      yield put({ type: REQUEST_FAILURE, error });
    }
  }
}

export function* updateCompanyInfoFlow() {
  while (true) {
    const request = yield take(UPDATE_COMPANY_INFO_REQUEST);
    const { companyId, body, cb, enableCb = false } = request.payload;
    try {
      let response;
      response = yield call(putMethod, {
        url: settings.getApiUrl(
          `service/enlm_ms/api_internal/company/${companyId}`
        ),
        body
      });
      const { success, result } = response;
      if (success && result.success) {
        const { company_info, company, eligible_for_ein } = response.result;
        const country = lodashGet(company, `address.country`);
        const belongsToList = getBelongsTo(country);
        yield put({
          type: UPDATE_COMPANY_INFO_SUCCESS,
          companyInfo: company_info,
          company,
          eligibleForEin: eligible_for_ein,
          message: 'Details updated successfully',
          countryCode: country,
          ...belongsToList
        });
        if (enableCb) cb();
      } else {
        yield put({
          type: UPDATE_COMPANY_INFO_FAILURE,
          error: result.message || result.messages
        });
      }
    } catch (error) {
      yield put({ type: UPDATE_COMPANY_INFO_FAILURE, error });
    }
  }
}

export function* getBannerData() {
  while (true) {
    const request = yield take(GET_BANNER_DATA_REQUEST);
    try {
      let response;
      const { countryCode = '' } = request.payload;
      response = yield call(get, {
        url: settings.getApiUrl(
          `service/enlm_ms/api_internal/account/data${
            countryCode ? `?country_code=${countryCode}` : ''
          }`
        )
      });
      const { success, result } = response;
      if (success) {
        yield put({
          type: GET_BANNER_DATA_SUCCESS,
          bannerNotice: result.banner_notices,
          licenseTypes: lodashGet(
            result,
            'company_master_data.license_types',
            []
          ),
          availableLocales: result.available_locales
        });
      } else {
        yield put({
          type: REQUEST_FAILURE,
          error: result.message || result.messages
        });
      }
    } catch (error) {
      yield put({ type: REQUEST_FAILURE, error });
    }
  }
}

export function* getImageBannerData() {
  while (true) {
    yield take(GET_IMAGE_BANNER_DATA_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`bannerNotices`),
        withBearer: true
      });
      const { status, result } = response;
      if (status === 200) {
        const imageBanner = response.result || [];
        yield put({ type: GET_IMAGE_BANNER_DATA_SUCCESS, imageBanner });
      } else {
        yield put({
          type: REQUEST_FAILURE,
          error: result.message || result.messages
        });
        console.log(
          'Saga: getImageBannerData',
          result.message || result.messages
        );
      }
    } catch (error) {
      console.log('Saga: getImageBannerData', error);
    }
  }
}

export function* getSFDCStats() {
  while (true) {
    const request = yield take(GET_SFDC_REQUEST);
    try {
      let response;
      const { successCbk = () => {} } = request.payload;
      response = yield call(get, {
        url: settings.einCoreUrl('installer/getSFDCStats'),
        withBearer: true
      });
      if (response.success) {
        const accountManagerInfo = lodashGet(
          response,
          'result.acc_mgr_info',
          {}
        );
        const communityInfo = lodashGet(response, 'result.community_info', {});
        yield put({ type: GET_SFDC_SUCCESS, communityInfo });
        if (!isEmpty(accountManagerInfo)) {
          successCbk(accountManagerInfo);
        } else {
          yield put({ type: GET_SFDC_FAILURE });
        }
      } else {
        yield put({ type: GET_SFDC_FAILURE });
      }
    } catch (error) {
      console.log('Saga: getSFDCStats:', error);
      yield put({ type: GET_SFDC_FAILURE });
    }
  }
}

export function* updateAccountMangerInfo() {
  while (true) {
    const request = yield take(UPDATE_ACCOUNT_MANAGER_REQUEST);
    try {
      let response;
      const { accountManagerInfo, companyId } = request.payload;
      const body = {
        company_mongo: {
          account_manager_attributes: {
            name: lodashGet(accountManagerInfo, 'name', ''),
            email: lodashGet(accountManagerInfo, 'email', ''),
            phone:
              lodashGet(accountManagerInfo, 'phone', '') ||
              lodashGet(accountManagerInfo, 'mobile', '')
          },
          skip_profile_validation: true,
          skip_lead_program_validations: true
        }
      };
      response = yield call(putMethod, {
        url: settings.getApiUrl(
          `service/enlm_ms/api_internal/company/${companyId}`
        ),
        body
      });
      const { success, result } = response;
      if (success && result.success) {
        const { company_info, company, eligible_for_ein } = response.result;
        const country = lodashGet(company, `address.country`);
        const belongsToList = getBelongsTo(country);
        yield put({
          type: UPDATE_ACCOUNT_MANAGER_SUCCESS,
          companyInfo: company_info,
          company,
          eligibleForEin: eligible_for_ein,
          countryCode: country,
          ...belongsToList
        });
      } else {
        yield put({ type: UPDATE_ACCOUNT_MANAGER_FAILURE });
      }
    } catch (error) {
      console.log('Saga: updateAccountMangerInfo:', error);
      yield put({ type: UPDATE_ACCOUNT_MANAGER_FAILURE });
    }
  }
}

export function* getABFeatureList() {
  while (true) {
    const request = yield take(GET_AB_FEATURE_REQUEST);
    try {
      let response;
      const { email, companyId } = request.payload;
      response = yield call(post, {
        url: settings.getApiUrl(
          `service/enlm_ms/api_internal/account/ab_features`
        ),
        body: {
          feature: {
            email: email,
            company_id: companyId,
            country_code: 'user_company_country'
          }
        }
      });
      const { success, result } = response;
      if (success) {
        yield put({ type: GET_AB_FEATURE_SUCCESS, featureList: result });
      } else {
        yield put({
          type: GET_AB_FEATURE_FAILURE,
          error: result.message || result.messages
        });
      }
    } catch (error) {
      console.log('Saga: getABFeatureList:', error);
      yield put({ type: GET_AB_FEATURE_FAILURE, error });
    }
  }
}

export function* getUserDetails() {
  while (true) {
    yield take(GET_USER_DETAILS);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl('installer/companyInfo'),
        withBearer: true
      });
      const { success, result } = response;
      if (success) {
        const {
          company_name,
          logo_url,
          country,
          state,
          ein_opt_in,
          ein_opt_out,
          installing_since,
          sites_count,
          storages_count,
          micro_inverters_count,
          company_tier,
          ensemble_training,
          solar_install_certification
        } = result;
        const belongsToList = getBelongsTo(country);
        yield put({
          type: GET_USER_DETAILS_SUCCESS,
          countryCode: country,
          companyName: company_name,
          companyState: state,
          logoUrl: logo_url,
          einOptIn: ein_opt_in,
          einOptOut: ein_opt_out,
          installingSince: installing_since,
          sitesCount: sites_count,
          storagesCount: storages_count,
          microinvertersCount: micro_inverters_count,
          companyTier: company_tier,
          ensembleTraining: ensemble_training,
          solarInstallCertification: solar_install_certification,
          ...belongsToList
        });
      } else {
        yield put({
          type: GET_USER_DETAILS_FAILURE,
          error: result.message || result.messages
        });
      }
    } catch (error) {
      console.log('Saga: getUserDetails:', error);
      yield put({ type: GET_USER_DETAILS_FAILURE, error });
    }
  }
}

export function* getApplicationNotificationsFlow() {
  while (true) {
    const request = yield take(GET_APPLICATION_NOTIFICATIONS_REQUEST);
    try {
      let response;
      const { successCbk = () => {}, page = 0, size = 20 } = request.payload;
      response = yield call(get, {
        url: settings.einCoreUrl(`notifications/?page=${page}&size=${size}`),
        withBearer: true
      });
      if (response.success) {
        const notificationList = response.result.notices || [];
        const unseenNotificationCount =
          response.result['unseen_notifications_count'];
        successCbk(notificationList);
        yield put({
          type: GET_APPLICATION_NOTIFICATIONS_SUCCESS,
          notificationList: notificationList,
          unseenNotificationCount: unseenNotificationCount
        });
      } else {
        yield put({
          type: GET_APPLICATION_NOTIFICATIONS_FAILURE,
          error: response.result.message || response.result.messages
        });
      }
    } catch (error) {
      yield put({ type: GET_APPLICATION_NOTIFICATIONS_FAILURE, error });
      console.log('Saga: getApplicationNotifications ', error);
    }
  }
}

export function* readApplicationNotificationFlow() {
  while (true) {
    const request = yield take(READ_APPLICATION_NOTIFICATIONS_REQUEST);
    try {
      let response;
      const { installerId, successCbk = () => {} } = request.payload;
      response = yield call(putMethod, {
        url: settings.einCoreUrl(`notifications/${installerId}`),
        withBearer: true
      });
      if (response.success) {
        successCbk();
      } else {
        yield put({
          type: READ_APPLICATION_NOTIFICATIONS_FAILURE,
          error: response.result.message || response.result.messages
        });
      }
    } catch (error) {
      yield put({ type: READ_APPLICATION_NOTIFICATIONS_FAILURE, error });
      console.log('Saga: readApplicationNotificationFlow ', error);
    }
  }
}

export function* markNotificationSeenFlow() {
  while (true) {
    const request = yield take(MARK_NOTIFICATION_AS_SEEN_REQUEST);
    try {
      let response;
      const { lastUpdatedAt, successCbk = () => {} } = request.payload;
      response = yield call(putMethod, {
        url: settings.einCoreUrl(`notifications/seen/${lastUpdatedAt}`),
        withBearer: true
      });
      if (response.success) {
        successCbk();
      } else {
        console.log('Saga: readApplicationNotificationFlow ');
      }
    } catch (error) {
      console.log('Saga: readApplicationNotificationFlow ', error);
    }
  }
}

let applicationloading = false;
export function* getApplicationBySiteFlow() {
  while (true) {
    const request = yield take(GET_APPLICATION_REQUEST);
    const { siteId, cbk = () => {} } = request.payload;
    if (!applicationloading) {
      try {
        let response;
        applicationloading = true;
        response = yield call(get, {
          url: settings.permittingUrl(`application_by_site?site_id=${siteId}`),
          withBearer: true
        });
        const { success, status, result } = response;
        if (success && status === 200) {
          yield put({ type: GET_APPLICATION_SUCCESS });
          cbk(result);
        } else {
          yield put({ type: GET_APPLICATION_FAILURE });
          cbk(result);
        }
        applicationloading = false;
      } catch (error) {
        yield put({ type: GET_APPLICATION_FAILURE });
        cbk({ status: 'failed' });
        applicationloading = false;
      }
    }
  }
}

export function* deleteApplicationNotificationFlow() {
  while (true) {
    const request = yield take(DELETE_READ_NOTIFICATION_REQUEST);
    try {
      let response;
      const { notificationId, successCbk = () => {} } = request.payload;
      response = yield call(deleteMethod, {
        url: settings.einCoreUrl(`notifications/${notificationId}`),
        withBearer: true
      });
      if (response.success) {
        successCbk();
      } else {
        console.log(
          'Saga: deleteApplicationNotificationFlow ',
          response.result.message || response.result.messages
        );
      }
    } catch (error) {
      console.log('Saga: deleteApplicationNotificationFlow ', error);
    }
  }
}

let requestSent = false;
export function* requestSolargrafAccess() {
  while (true) {
    const request = yield take(GET_SOLARGRAF_ACCESS);
    const { successCbk = () => {}, failureCbk = () => {} } = request.payload;
    if (!requestSent) {
      try {
        requestSent = true;
        const response = yield call(post, {
          url: settings.getApiUrl('api_internal/solargraf/request_access')
        });
        const { success, status } = response;
        if (success && status === 200) {
          successCbk();
        } else {
          failureCbk();
        }
        requestSent = false;
      } catch (error) {
        failureCbk();
        requestSent = false;
      }
    }
  }
}

let grantAccessRequestSent = false;
export function* grantSolargrafAccess() {
  while (true) {
    const request = yield take(SET_SOLARGRAF_ACCESS_GRANT);
    const {
      otp,
      successCbk = () => {},
      failureCbk = () => {}
    } = request.payload;
    if (!grantAccessRequestSent) {
      try {
        grantAccessRequestSent = true;
        const response = yield call(post, {
          url: settings.getApiUrl(
            `api_internal/solargraf/grant_access?otp=${otp}`
          )
        });
        const { success, status } = response;
        if (success && status === 200) {
          successCbk();
        } else {
          failureCbk();
        }
        grantAccessRequestSent = false;
      } catch (error) {
        failureCbk();
        grantAccessRequestSent = false;
      }
    }
  }
}

export function* getSolargrafSession() {
  while (true) {
    const request = yield take(GET_SOLARGRAF_SESSION);
    const {
      token,
      successCbk = () => {},
      failureCbk = () => {}
    } = request.payload;
    try {
      let response;
      // Token in URL is not a risk as api call encrypted
      response = yield call(post, {
        url: settings.solargrafApiUrl(`enlm/sessions?token=${token}`)
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        setSolargrafToken(result.token);
        yield put({
          type: GET_SOLARGRAF_SESSION_SUCCESS,
          solargrafToken: result.token
        });
        successCbk(result);
      } else {
        failureCbk();
      }
    } catch (error) {
      failureCbk();
    }
  }
}

export function* verifySolargrafSession() {
  while (true) {
    const request = yield take(VERIFY_SOLARGRAF_SESSION);
    const {
      solargrafToken,
      successCbk = () => {},
      failureCbk = () => {}
    } = request.payload;

    try {
      let response;
      response = yield call(get, {
        url: settings.solargrafApiUrl(`me`),
        withBearer: true,
        externalServiceToken: solargrafToken
      });
      const { success, status } = response;
      if (success && status === 200) {
        successCbk();
      } else {
        failureCbk();
      }
    } catch (error) {
      failureCbk();
    }
  }
}

export function* verifySolargrafEmail() {
  while (true) {
    const request = yield take(VERIFY_SOLARGRAF_EMAIL);
    const {
      token,
      successCbk = () => {},
      failureCbk = () => {}
    } = request.payload;
    try {
      let response;
      // Token in URL is not a risk as api call is encrypted
      response = yield call(get, {
        url: settings.solargrafApiUrl(`enlm/verification?token=${token}`)
      });
      const { success, status } = response;
      if (success && status === 200) {
        successCbk();
      } else {
        failureCbk();
      }
    } catch (error) {
      failureCbk();
    }
  }
}

export function* getProjectDetails() {
  while (true) {
    const request = yield take(GET_PROJECT_DETAILS_REQUEST);
    const {
      projectId,
      solargrafToken,
      successCbk = () => {}
    } = request.payload;

    try {
      let response;
      response = yield call(get, {
        url: settings.solargrafApiUrl(`projects/${projectId}`),
        withBearer: true,
        externalServiceToken: solargrafToken
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        yield put({
          type: GET_PROJECT_DETAILS_SUCCESS,
          projectDetails: result
        });
        successCbk();
      } else {
        yield put({ type: GET_PROJECT_DETAILS_FAILURE });
      }
    } catch (error) {
      yield put({ type: GET_PROJECT_DETAILS_FAILURE });
    }
  }
}

export function* getSiteDetailsFlow() {
  while (true) {
    const request = yield take(GET_SITE_DETAILS_REQUEST);
    try {
      let response;
      const { siteId = '' } = request.payload;
      response = yield call(get, {
        url: settings.getApiUrl(
          `service/enlm_ms/api_internal/sites/search?search_value=${siteId}&search_type=all_stages`
        )
      });
      if (response.success) {
        yield put({
          type: GET_SITE_DETAILS_SUCCESS,
          siteDetails: response.result.result
        });
      } else {
        yield put({
          type: GET_SITE_DETAILS_FAILURE,
          error: response.result.message
        });
      }
    } catch (error) {
      yield put({ type: GET_SITE_DETAILS_FAILURE, error: error });
    }
  }
}

export function* canApplyDRSForCertificationCourseFlow() {
  while (true) {
    const request = yield take(CAN_APPLY_DRS_FOR_CC_REQUEST);
    let siteId = null;
    if (request.payload) {
      siteId = request.payload.site_id;
    }
    let endUrl;
    if (siteId === null) {
      endUrl = `applications/certificationCourse`;
    } else {
      endUrl = `applications/certificationCourse?site_id=${siteId}`;
    }
    try {
      const response = yield call(get, {
        url: settings.getDrsUrl(endUrl),
        withBearer: true
      });
      if (response.success) {
        yield put({
          type: CAN_APPLY_DRS_FOR_CC_SUCCESS,
          canApplyDRSForCC: lodashGet(
            response.result,
            'university_application',
            false
          ),
          drsIdForLeftPanel: lodashGet(response.result, 'drs_id', '')
        });
      } else {
        yield put({
          type: CAN_APPLY_DRS_FOR_CC_FAILURE,
          error: response.result.message
        });
      }
    } catch (error) {
      yield put({ type: CAN_APPLY_DRS_FOR_CC_FAILURE, error: error });
    }
  }
}

export function* createDrsApplicationFlow() {
  while (true) {
    const request = yield take(CREATE_DRS_APPLICATION_REQUEST);
    const {
      application,
      siteId,
      successCbk,
      applyForCC = false,
      installerCountry
    } = request.payload;
    try {
      let response;
      // this case will not arise for left panel needs so currently having no reducer for this is enlm
      if (!isEmpty(lodashGet(application, 'drs_id', ''))) {
        response = yield call(putMethod, {
          url: settings.getDrsUrl(`applications/${application.drs_id}`),
          withBearer: true,
          body: application
        });
      } else {
        response = yield call(post, {
          url: settings.getDrsUrl(
            `applications/${siteId}/new?apply_for_cc=${applyForCC}&installer_country=${installerCountry}`
          ),
          withBearer: true
        });
      }
      const { success, status, result } = response;
      if (success && status === 200) {
        yield put({
          type: CREATE_DRS_APPLICATION_SUCCESS,
          application: result,
          message: 'Application saved'
        });
        if (
          !isEmpty(lodashGet(result, 'drs_id', '')) &&
          lodashGet(result, 'current_status.state_id', 0) === 0
        ) {
          successCbk(result.drs_id);
        }
      } else {
        yield put({
          type: CREATE_DRS_APPLICATION_FAILURE,
          message: result.message || result.messages
        });
      }
    } catch (error) {
      console.log('Saga: createDrsApplicationFlow:', error);
      yield put({ type: CREATE_DRS_APPLICATION_FAILURE, message: error });
    }
  }
}

export function* getEnlightenVersionFooterFlow() {
  while (true) {
    const request = yield take(GET_ENLIGHTEN_VERSION_FOOTER);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl('manager_healthcheck')
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        yield put({
          type: SET_ENLIGHTEN_VERSION_FOOTER,
          payload: result.VERSION
        });
      } else {
        const responseFallback = yield call(get, {
          url: settings.getApiUrl('service/enlm_ms/healthcheck')
        });
        const {
          success: successFallback,
          status: statusFallback,
          result: resultFallback
        } = responseFallback;
        if (statusFallback && statusFallback === 200) {
          yield put({
            type: SET_ENLIGHTEN_VERSION_FOOTER,
            payload: resultFallback.VERSION
          });
        } else {
          yield put({ type: SET_ENLIGHTEN_VERSION_FOOTER, payload: null });
        }
      }
    } catch (error) {
      yield put({ type: SET_ENLIGHTEN_VERSION_FOOTER, payload: null });
    }
  }
}
